import React from "react";
import TabList from "./TabBar.styles";
import { wrapper } from "../../types";
const defaultProps = wrapper;
const TabBar = ({ children, className }) => {
  const classes = ["tab-bar", className].filter(Boolean).join(" ");
  return /* @__PURE__ */ React.createElement(TabList, {
    role: "tablist",
    className: classes
  }, children);
};
TabBar.defaultProps = defaultProps;
export default TabBar;
